module.exports = "<div layout layout-align=\"start center\" class=\"login-button\"> <span hide-xs>Already have an account?</span> <button type=\"button\" class=\"checkout-button checkout-button--border\" ng-click=\"$ctrl.onLoginClicked()\"> Sign in </button> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/loginButton/loginButton.html
// module id = 875
// module chunks = 0